<template>
  <div>
    <van-swipe :style="{'height':windowHeight+'px'}"
      :loop="false"
      :show-indicators="false"
      vertical>
      <van-swipe-item>
        <!-- 首页-封面 -->
        <div class="bgImage"
          :style="{'max-height':windowHeight+'px'}">
          <img src="https://xajmylapi.anluoyun.cn//upload/images/2023/3/1a31dd95-104.jpg"
            alt="">
          <!-- <div class="bgImage01">

        </div> -->
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div>
          <!-- <img src="https://xajmylapi.anluoyun.cn//upload/images/2023/3/d6e4c268-508.jpg"
        alt=""
        style="float:left;"> -->
          <div class="bgImage bgImage02">
            <h2 class="title">老人性别分布图</h2>
            <div id="sex"
              style="width: 90%; height: 300px;top:22vh; margin: auto;">
            </div>
          </div>

          <!-- 老人性别分布图 -->

        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div>
          <div class="bgImage bgImage03"
            :style="{'max-height':windowHeight+'px'}">
            <h2 class="title">老人年龄区间分布</h2>
            <div id="ageEcharts"
              style="width: 90%; height: 300px;top:22vh; margin: auto;">
            </div>
          </div>

        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div>
          <div class="bgImage bgImage04"
            :style="{'max-height':windowHeight+'px'}">
            <h2 class="title">老人社区信息分布图</h2>
            <div id="organEcharts"
              style="width: 90%; height: 300px;top:22vh; margin: auto;">
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div>
          <div class="bgImage bgImage07"
            :style="{'max-height':windowHeight+'px'}">
            <h2 class="title">基本养老需求分析图</h2>
            <div id="oldManNeed"
              style="width: 90%; height: 300px;top:22vh; margin: auto;">
            </div>
          </div>

        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div>
          <div class="bgImage bgImage08"
            :style="{'max-height':windowHeight+'px'}">
            <h2 class="title">老人服务同比图</h2>
            <div id="oldManTb"
              style="width: 90%; height: 300px;top:22vh; margin: auto;">
            </div>
          </div>

        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div>
          <div class="bgImage bgImage09"
            :style="{'max-height':windowHeight+'px'}">
            <h2 class="title">老人服务趋势</h2>
            <div id="oldTrend"
              style="width: 90%; height: 300px;top:22vh; margin: auto;">
            </div>
          </div>

        </div>
      </van-swipe-item>
    </van-swipe>

    <!-- <div>
      <div class="bgImage bgImage05"
        :style="{'max-height':windowHeight+'px'}">
        <h2 class="title">老人基础疾病分析图</h2>
        <div id=""
          style="width: 90%; height: 300px;top:22vh; margin: auto;">
        </div>
      </div>

    </div> -->
    <!-- <div>
      <div class="bgImage bgImage06"
        :style="{'max-height':windowHeight+'px'}">
        <h2 class="title">老人基础疾病分析图</h2>
        <div id=""
          style="width: 90%; height: 300px;top:22vh; margin: auto;">
        </div>
      </div>

    </div> -->

  </div>
</template>

<script>
import {
  WOTrendOfSO,
  WorkOrderTrendOfDay,
  RegionStat,
  OldManAgeStat,
  OldManSexStat,
  OldManDemandStat,
} from "@/api/oldman";
export default {
  data () {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      timer: null, //定时器名称
      xSexTotal: ['135', '764'],
      accToken: '2a343a39453958356b344e3130635f386b304834796255315834216635616d3135613538306335366d653530353670627c37706635367d3747342f354b61513335342f395139613561348056',
    }
  },
  watch: {
    windowHeight (val) {
      let that = this;
    },
  },
  mounted () {
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight; // 高
      })();
    };
    this.getOldSex();
    // 年龄分布
    this.getOldManAgeStat();
    // 老人社区分布
    this.getRegionStat();
    // 获取养老需求
    this.getOldManNeedList()
    // 服务同比
    this.workOrderTrendOfDay()
    // 获取养老服务趋势
    this.getOldTrendList()
    this.timer = setInterval(() => {
      // 获取性别比例
      this.getOldSex();
      // 年龄分布
      this.getOldManAgeStat();
      // 老人社区分布
      this.getRegionStat();
      // 获取养老需求
      this.getOldManNeedList()
      // 服务同比
      this.workOrderTrendOfDay()
      // 获取养老服务趋势
      this.getOldTrendList()

    }, 10000);
  },
  methods: {
    // 性别统计
    getOldSex () {
      OldManSexStat({ accToken: this.accToken }).then((res) => {
        if (res.data.code == 0) {
          this.getSex([res.data.womanNum, res.data.manNum]);
        }

      });
    },
    // 获取养老需求
    getOldManNeedList () {
      OldManDemandStat({ accToken: this.accToken }).then((res) => {
        if (res.data.code == 0) {
          let Title = [];
          let Total = [];
          res.data.data.forEach((element) => {
            Title.push(element.Title);
            Total.push(element.Total);
          });
          this.getOldManNeed(Title, Total);
        }

      });
    },
    // 年龄统计
    getOldManAgeStat () {
      OldManAgeStat({ accToken: this.accToken }).then((res) => {
        if (res.data.code == 0) {
          this.getAge([res.data.overHundred, res.data.ninetyAndHundred, res.data.eightyAndNinety, res.data.seventyAndEighty, res.data.sixtyAndSeventy,]);
        }

      });
    },

    // 老人社区分布
    getRegionStat (res) {
      RegionStat({ accToken: this.accToken }).then((res) => {
        if (res.data.code == 0) {
          let Title = [];
          let Total = [];
          res.data.data.forEach((element) => {
            Title.push(element.Title);
            Total.push(element.Total);
          });
          this.getOldManOrgan(Title, Total);
        }

      });
    },
    // 服务同比
    workOrderTrendOfDay () {
      WorkOrderTrendOfDay({ accToken: this.accToken, soId: '6' }).then((res) => {
        if (res.data.code == 0) {
          var value = res.data.data
          // console.log(value)
          var todayNum = []
          var statTime = []
          var beforeYesterdayNum = []
          var yesterdayNum = []
          for (let i = 0; i < value.length; i++) {
            todayNum.push(value[i].TodayNum)
            statTime.push(value[i].StatTime)
            beforeYesterdayNum.push(value[i].BeforeYesterdayNum)
            yesterdayNum.push(value[i].YesterdayNum)
          }
          this.getOldManTb(todayNum, statTime, beforeYesterdayNum, yesterdayNum)
        }
      });
    },
    // 获取养老服务趋势
    getOldTrendList () {
      var timeNameDx = []
      var timeCountDx = []
      var timeCountBl = []
      WOTrendOfSO({
        accToken: this.accToken
      }).then((res) => {
        if (res.data.code == 0) {
          var value = res.data.data
          // console.log(value)
          for (let i = 0; i < value[0].Detail.length; i++) {
            const e = value[0].Detail[i]
            timeNameDx.push(e.Days)
            timeCountDx.push(e.SerNum)
          }
          for (let b = 0; b < value[1].Detail.length; b++) {
            const c = value[1].Detail[b]
            timeCountBl.push(c.SerNum)
          }
          // 服务趋势
          this.getOldTrend(timeNameDx, timeCountDx, timeCountBl)
        }
      })
    },
    // 获取性别比例
    getSex (row) {
      var yAxisData = ['女性', '男性'];
      var xSexTotal = row;
      var color = ['#a8e0fa', '#4ee0c1'];
      let myChart = this.$echarts.init(document.getElementById("sex"));
      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        legend: {
          data: ['女性', '男性'],
          top: "15%",
          textStyle: {
            color: "#ffffff"
          }
        },
        tooltip: {
          formatter: '{b} ({c})'
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [{
          gridIndex: 0,
          position: 'top',
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff',
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 14
            }
          },
          axisTick: {
            show: false
          },

        },],
        yAxis: [{
          gridIndex: 0,
          interval: 0,
          data: yAxisData.reverse(),
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'white',
            }
          },
          axisTick: {
            show: false
          },

        }],
        series: [{
          type: 'bar',
          xAxisIndex: 0,
          yAxisIndex: 0,
          barWidth: '45%',
          itemStyle: {
            normal: {
              color: (val) => {
                if (val.dataIndex < 3) {
                  return color[val.dataIndex];
                } else {
                  return '#1990FF'
                }
              },
            }
          },
          label: {
            normal: {
              show: true,
              position: "right",
              textStyle: {
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }
            }
          },
          data: xSexTotal
        },]
      });
      // let app = {
      //   currentIndex: -1
      // };
      // setInterval(function () {
      //   let dataLen = xSexContent[0].data.length;
      //   // 取消之前高亮的图形
      //   myChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0,
      //     dataIndex: app.currentIndex
      //   });
      //   app.currentIndex = (app.currentIndex + 1) % dataLen;
      //   //console.log(app.currentIndex);
      //   // 高亮当前图形
      //   myChart.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: app.currentIndex
      //   });
      //   // 显示 tooltip
      //   myChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: app.currentIndex
      //   });
      // }, 1000);
      // window.onresize = myChart.resize;

    },
    // 年龄分布
    getAge (row) {

      var color = ['#5aaef3', '#62d9ad', '#5b6e96', '#a8dffa', '#ffdc4c'];
      let myChart = this.$echarts.init(document.getElementById("ageEcharts"));
      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: ['百岁以上', '90-100岁', '80-90岁', '70-80岁', '60-70岁'],
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff',
            }
          },
          axisLabel: {
            show: true,
            //坐标轴刻度标签的相关设置
            interval: 0, //横轴信息全部显示
            rotate: 30, //60度角倾斜显示
            textStyle: {
              color: '#fff',
              fontSize: 14,
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "white",
              fontSize: "16px",
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'white',
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,.1)',
            },
          },
        }],
        series: [{
          type: 'bar',
          data: row,
          barWidth: '20px',
          itemStyle: {
            normal: {
              color: (val) => {
                if (val.dataIndex < 3) {
                  return color[val.dataIndex];
                } else {
                  return '#1990FF'
                }
              },
            }
          },
          label: {
            normal: {
              show: true,
              lineHeight: 30,
              formatter: '{c}',
              position: 'top',
              textStyle: {
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }

            }
          }
        }]
      });
    },
    // 社区分布
    getOldManOrgan (Title, Total) {
      let myChart = this.$echarts.init(document.getElementById("organEcharts"));
      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: Title,
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#fff',
              }
            },
            axisLabel: {
              show: true,
              //坐标轴刻度标签的相关设置
              interval: 0, //横轴信息全部显示
              rotate: 60, //60度角倾斜显示
              textStyle: {
                color: '#fff',
                fontSize: 14,
              }
            },
            axisTick: {
              show: false
            },
          }
        ],
        yAxis: [{
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "white",
              fontSize: "16px",
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'white',
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,.1)',
            },
          },
        }],
        series: [{
          type: 'bar',
          data: Total,
          barWidth: '15px',
          itemStyle: {
            normal: {
              color: '#a8dffa'
            },

          },
          // label: {
          //   normal: {
          //     show: true,
          //     lineHeight: 30,
          //     formatter: '{c}',
          //     position: 'top',
          //     textStyle: {
          //       color: "white",
          //       fontSize: "16px",
          //       fontWeight: "600",
          //     }

          //   }
          // }
        }]
      });
    },
    // 养老需求
    getOldManNeed (Title, Total) {
      var dataStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          // shadowBlur: 15,
          // shadowColor: 'white',
        }
      };
      var placeHolderStyle = {
        normal: {
          color: 'rgba(0,0,0,0)',
          label: {
            show: false
          },
          labelLine: {
            show: false
          }
        },
        emphasis: {
          color: 'rgba(0,0,0,0)'
        }
      };
      let myChart = this.$echarts.init(document.getElementById("oldManNeed"));
      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        color: ['#95d3d4', '#f5cc44', '#e0efcf', '#b7dfcb'],
        tooltip: {
          show: true,
          formatter: "{b} : {c}"
        },

        legend: {
          top: "12.5%",
          x: 'right',
          left: "32%",
          itemWidth: 0, itemHeight: 0,
          data: [Title[1], Title[6], Title[2], Title[0]],
          itemGap: 8,
          textStyle: {
            color: '#fff',
            align: 'right',
            x: 'right',
            textAlign: 'right'
          },

          selectedMode: true,
          orient: "vertical",

        },
        series: [
          {
            name: 'Line 4',
            type: 'pie',
            clockWise: true,
            hoverAnimation: false,
            radius: ['65%', '75%'],
            itemStyle: dataStyle,
            label: {
              show: true,
              formatter: "Total[1]",
              color: 'RGB(246,175,101)',
              fontSize: 25,
              position: 'inside'
            },
            data: [{
              value: Total[1],
              name: '助洁',
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  normal: {
                    color: '#dc1439'
                  }
                }
              }
            }, {
              value: 4000,
              name: '总数',
              tooltip: {
                show: false
              },
              itemStyle: placeHolderStyle
            }],

          }, {
            name: 'Line 3',
            type: 'pie',
            clockWise: true,
            radius: ['50%', '60%'],
            itemStyle: dataStyle,
            hoverAnimation: false,

            data: [{
              value: Total[6],
              name: '巡访关爱'
            }, {
              value: 10000,
              name: '总数',
              tooltip: {
                show: false
              },
              itemStyle: placeHolderStyle
            }]
          }, {
            name: 'Line 2',
            type: 'pie',
            clockWise: true,
            hoverAnimation: false,
            radius: ['35%', '45%'],
            itemStyle: dataStyle,

            data: [{
              value: Total[2],
              name: '助行'
            }, {
              value: 4000,
              name: '总数',
              tooltip: {
                show: false
              },
              itemStyle: placeHolderStyle
            }]
          },
          {
            name: 'Line 1',
            type: 'pie',
            clockWise: true,

            radius: ['20%', '30%'],
            itemStyle: dataStyle,
            hoverAnimation: false,

            data: [{
              value: Total[0],
              name: '助餐'
            }, {
              value: 4000,
              name: '总数',
              tooltip: {
                show: false
              },
              itemStyle: placeHolderStyle
            }

            ]
          }
        ]
      });
    },
    // 服务同比
    getOldManTb (todayNum, statTime, beforeYesterdayNum, yesterdayNum) {
      let myChart = this.$echarts.init(document.getElementById("oldManTb"));
      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        tooltip: { //提示框组件
          trigger: 'axis',
          formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}',
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            color: 'black',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 16,
          }
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '10%',
          top: 30,
          padding: '0 0 10 0',
          containLabel: true,
        },
        legend: {//图例组件，颜色和名字
          bottom: '1%',
          itemGap: 26,
          itemWidth: 18,
          itemHeight: 10,
          data: [{
            name: '前天',
          },
          {
            name: '昨天',
          },
          {
            name: '今天',
          }],
          textStyle: {
            color: 'white',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 12,
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,//坐标轴两边留白
            data: ['7:30', '10:30', '13:30', '16:30', '19:30', '19:30以后'],
            axisLabel: {
              // interval: 2, //横轴信息全部显示
              // rotate: 30, //60度角倾斜显示
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            },
            axisLine: {
              lineStyle: {
                color: '#fff',
              },
            },
          },
          {
            axisPointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            position: 'bottom',
            offset: 20,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#fff',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            },

            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)',
              },
            },
          },
        ],
        series: [
          {
            name: '前天',
            type: 'bar',
            data: beforeYesterdayNum,
            barWidth: 10,
            barGap: 0,//柱间距离
            label: {//图形上的文本标签
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#5aaef3',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                  fontWeight: 600,
                },
              },
            },
            itemStyle: {//图形样式
              normal: {
                color: '#5aaef3',
              },
            },
          },
          {
            name: '昨天',
            type: 'bar',
            data: yesterdayNum,
            barWidth: 10,
            barGap: 0.5,//柱间距离
            label: {//图形上的文本标签
              normal: {
                show: true,
                position: 'top',

                lineHeight: 20,
                textStyle: {
                  color: '#62d9ad',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                  fontWeight: 600,
                },
              },
            },
            itemStyle: {//图形样式
              normal: {
                color: '#62d9ad',
              },
            },
          },
          {
            name: '今天',
            type: 'bar',
            data: todayNum,
            barWidth: 10,
            barGap: 0.5,//柱间距离
            label: {//图形上的文本标签
              normal: {
                show: true,
                position: 'top',
                lineHeight: 40,
                textStyle: {
                  color: '#5b6e96',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                  fontWeight: 600,
                },
              },
            },
            itemStyle: {//图形样式
              normal: {
                color: '#5b6e96',
              },
            },
          }
        ]
      });
    },
    // 服务趋势
    getOldTrend (name, timeCountDx, timeCountBl) {
      var Sum = []
      for (let i = 0; i < timeCountDx.length; i++) {
        Sum.push(timeCountDx[i] + timeCountBl[i])
      }
      let myChart = this.$echarts.init(document.getElementById("oldTrend"));

      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontSize: 16,
          },
          axisPointer: {
            lineStyle: {
              color: '#dddc6b',
            },
          },
        },
        legend: {
          bottom: '1%',
          data: ['服务总数', '得贤人力', '佰龄康护'],
          textStyle: {
            color: '#fff',
            fontSize: '12',
          },
        },
        grid: {
          left: '20',
          top: '30',
          right: '20',
          bottom: '30',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              // interval: 2, //横轴信息全部显示
              // rotate: 30, //60度角倾斜显示
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            },
            axisLine: {
              lineStyle: {
                color: '#fff',
              },
            },
            data: name,
          },
          {
            axisPointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            position: 'bottom',
            offset: 20,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#fff',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            },

            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)',
              },
            },
          },
        ],
        series: [
          {
            name: '服务总数',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: '#0184d5',
                width: 2,
              },
            },
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(1, 132, 213, 0.4)',
                    },
                    {
                      offset: 0.8,
                      color: 'rgba(1, 132, 213, 0.1)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
              },
            },
            itemStyle: {
              normal: {
                color: '#0184d5',
                borderColor: 'rgba(221, 220, 107, .1)',
                borderWidth: 12,
              },
            },
            data: Sum,
            label: {
              normal: {
                show: true,
                lineHeight: 20,
                formatter: '{c}',
                position: 'top',
                textStyle: {
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }

              }
            }
          },
          {
            name: '得贤人力',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: '#00d887',
                width: 2,
              },
            },
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(0, 216, 135, 0.4)',
                    },
                    {
                      offset: 0.8,
                      color: 'rgba(0, 216, 135, 0.1)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
              },
            },
            itemStyle: {
              normal: {
                color: '#00d887',
                borderColor: 'rgba(221, 220, 107, .1)',
                borderWidth: 12,
              },
            },
            data: timeCountDx,
            label: {
              normal: {
                show: true,
                lineHeight: 20,
                formatter: '{c}',
                position: 'top',
                textStyle: {
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }

              }
            }
          },
          {
            name: '佰龄康护',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                color: 'rgba(203,144, 99)',
                width: 2,
              },
            },
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(203,144, 99, 0.4)',
                    },
                    {
                      offset: 0.8,
                      color: 'rgba(203,144, 99, 0.1)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(203,144, 99)',
                borderColor: 'rgba(221, 220, 107, .1)',
                borderWidth: 12,
              },
            },
            data: timeCountBl,
            label: {
              normal: {
                show: true,
                lineHeight: 20,
                formatter: '{c}',
                position: 'top',
                textStyle: {
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                }

              }
            }
          },
        ],
        //         dataZoom: {
        //   show: true, // 为true 滚动条出现
        //   realtime: true,
        //   type: "slider", // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
        //   height: 15, // 表示滚动条的高度，也就是粗细
        //   start: 60, // 表示默认展示20%～80%这一段。
        //   end: 100,
        // },

      });
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
}
</script>
<style scoped>
.title {
  position: relative;
  top: 22vh;
  text-align: center;
  color: white;
}
.bgImage {
  background-size: 100% 100%;
  /* background-size: cover; */
  /* background-repeat: no-repeat; */
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
.bgImage img {
  width: 100%;
}
.bgImage01 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/1a31dd95-104.jpg');
}
.bgImage02 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/d6e4c268-508.jpg');
}
.bgImage03 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/eabdc081-334.jpg');
}
.bgImage04 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/1cd38a7f-f6e.jpg');
}
.bgImage05 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/23855961-27b.jpg');
}
.bgImage06 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/733cf513-ddd.jpg');
}
.bgImage07 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/c5cb8923-7ba.jpg');
}
.bgImage08 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/b9258260-a97.jpg');
}
.bgImage09 {
  background-image: url('https://xajmylapi.anluoyun.cn//upload/images/2023/3/0ef84710-de4.jpg');
}
</style>